module.exports = __webpack_public_path__ + "static/media/pepsi.27e31e0f.png";